import { render, staticRenderFns } from "./DrawerPolicyEditColumns.vue?vue&type=template&id=4dadd32e&scoped=true&"
import script from "./DrawerPolicyEditColumns.vue?vue&type=script&lang=js&"
export * from "./DrawerPolicyEditColumns.vue?vue&type=script&lang=js&"
import style0 from "./DrawerPolicyEditColumns.vue?vue&type=style&index=0&id=4dadd32e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dadd32e",
  null
  
)

export default component.exports